/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useState } from "react";
import {
  Box,
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  OutlinedInput,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MultiSelect = ({
  data,
  onChange,
  style,
  label,
  register,
  errors,
  message,
  file,
  keyField = 'Id',
  labelField = 'Name',
  singleSelect = false,
}) => {
  const [selected, setSelected] = useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    
    let newSelected = Array.isArray(value) ? value : [value];
    if (singleSelect) {
      
      newSelected = newSelected.length > 0 ? [newSelected[newSelected.length - 1]] : [];
    } else {

      newSelected = newSelected.filter(
        (val, index, self) =>
          index === self.findIndex((t) => t[keyField] === val[keyField])
      );
    }

    setSelected(newSelected);
    onChange(newSelected);
  };

  const isSelected = (item) => 
    selected.some(selectedItem => selectedItem[keyField] === item[keyField]);

  const isSelecteFile = (item) => {
    return selected.some(selectedItem => selectedItem.Id === item.Id);
  };
  
  const handleDelete = (valueToDelete) => () => {
    const newSelected = selected.filter(
      (value) => value[keyField] !== valueToDelete[keyField]
    );
    setSelected(newSelected);
    onChange(newSelected);
  };

  return (
    <div className="flex flex-col gap-2 font-main w-full">
      <label className="font-medium text-[#404040]">{label}</label>
      <Select
        multiple={!singleSelect}
        value={selected}
        onChange={handleChange}
        input={<OutlinedInput label="Select" {...register} />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip
              key={value[keyField]}
              label={value[labelField]}
              deleteIcon={
                <CloseIcon onMouseDown={(event) => event.stopPropagation()} />
              }
                onDelete={handleDelete(value)}
              />
            ))}
          </Box>
        )}
        sx={{ width: "100%", ...style }}
      >
        {data?.map((item) => (
          <MenuItem key={item[keyField]} value={item}>
            <Checkbox checked={isSelected(item)} />
            <ListItemText primary={item[labelField]} />
           </MenuItem>
        ))}
      </Select>
      {errors && <p className="text-red-500 text-sm">{message}</p>}
    </div>
  );
};

export default MultiSelect;
